import { render, staticRenderFns } from "./NavTabsTable.vue?vue&type=template&id=3d248e80"
import script from "./NavTabsTable.vue?vue&type=script&lang=js"
export * from "./NavTabsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports